<script>
import md5 from 'md5'
export default
{
    name: 'mv-user-image',

    props:
    {
        user: Object,
        hash: String,
        size:
        {
            type: Number,
            default: 80,
        },
        defaultImg:
        {
            type: String,
            default: 'retro'
        },
        rating:
        {
            type: String,
            default: 'g'
        },
    },

    computed:
    {
        url()
        {
            const email = this.user && this.user.email ? this.user.email : 'example@example.com'
            const img = [
                '//www.gravatar.com/avatar/',
                this.hash || md5(email.trim().toLowerCase()),
                `?s=${this.size}`,
                `&d=${this.defaultImg}`,
                `&r=${this.rating}`,
            ]
            return img.join('')
        },

        alt()
        {
            return this.user && this.user.name ? this.user.name : 'Avatar'
        },
    },

}
</script>

<template>
    <img :src="url" :alt="alt" :title="alt" class="circle-avatar">
</template>

<style lang="scss">
    .circle-avatar {
        margin-right: .5em;
        border-radius: 50%;
        box-shadow: 0 0 0 3px #fff, 4px 4px 8px #000;
    }
</style>


// WEBPACK FOOTER //
// src/components/UserImage.vue